import { render } from "./IntroWhatToDoSection.vue?vue&type=template&id=50caa600&scoped=true"
import script from "./IntroWhatToDoSection.vue?vue&type=script&lang=js"
export * from "./IntroWhatToDoSection.vue?vue&type=script&lang=js"

import "./IntroWhatToDoSection.vue?vue&type=style&index=0&id=50caa600&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50caa600"]])

export default __exports__